import request from '@/router/axios';

const getMagnitude = params => request({
  url: '/api/mcc-staff/assessmentsMasterlist/statisticalMagnitude',
  method: 'post',
  data: params,
});
const voluntarilyGetFormId = params => request({
  url: '/api/mcc-staff/assessmentsMasterlist/voluntarilyGetFormId',
  method: 'post',
  data: params,
});
const triggerSendNotice = params => request({
  url: '/api/mcc-staff/sopManagement/triggerSendNotice',
  method: 'post',
  data: params,
});
const query = params => request({
  url: '/api/mcc-staff/assessmentsMasterlist/page',
  method: 'get',
  params: {
    ...params,
  },
});
export default {
  getMagnitude,
  query,
  triggerSendNotice,
  voluntarilyGetFormId,
};
